import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { debounce } from 'lodash';
import { getCar } from 'redux/actions/UserCar';
import {
  getSubVendor,
  patchUpdateSubVendor,
  postAddSubVendor,
} from 'redux/actions/UserSubVendor';
import CommonButtonSubHeader from 'components/commonButtonSubHeader/CommonButtonSubHeader';
import CommonDialog from 'components/commonDialog/CommonDialog';
import CommonTable from 'components/commonTable/CommonTable';
import Loader from 'components/loader/Loader';
import BackDrop from 'components/backDrop/BackDrop';
import useModal from 'hooks/useModal';
import { filterdata } from 'pages/vehicle/VehiceData';
import { getDateFormat, handlePermissions } from 'utils/utils';
import { subVendorDialogData } from './SubVendorData';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';

const SubVendors = () => {
  const dispatch = useDispatch();
  const {state} = useLocation();
  const { open, toggle } = useModal();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [status, setStatus] = useState(state?.subVendorStatus ? state?.subVendorStatus?.split(','):'');
  const [search, setSearch] = useState('');
  const [id, setId] = useState(null);
  const [type, setType] = useState('');
  const [defaultValue, setDefaultValue] = useState({});
  const [modelOpen, setModelOpen] = useState(false);
  const companyId = localStorage.getItem('companyId');
  const companyName = localStorage.getItem('companyName');

  const subVendorDetails = useSelector(
    (state) => state?.userSubVendor?.userSubVendor?.data
  );
  const subVendorDetailsLoader = useSelector(
    (state) => state?.userSubVendor?.loading
  );

  // ----FormatingDate---
  const handleDateFormating = (data) => {
    return getDateFormat(data);
  };

  const cityManagerName = {
    vendorName: companyName,
  };

  let filterData = {
    id: state?.companyType === 'adminCompany' ? '' : companyId,
    status: status,
    page: page,
    pageSize: rowsPerPage,
    dateFrom: '',
    dateTo: '',
    search: search,
  };

  useEffect(() => {
    dispatch(getSubVendor(filterData));
    dispatch(getCar());
  }, []);

  const tableOnClickRow = (navigate, val) => {
    navigate(`/sub-vendor/details`, {
      state: {
        subVendorId: val.id,
        name: val.companyName,
        companyId: val.companyId,
        status: val.status,
      },
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(getSubVendor({ ...filterData, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(
      getSubVendor({
        ...filterData,
        page: 0,
        pageSize: parseInt(event.target.value),
      })
    );
  };

  const onFilterChange = (val) => {
    setPage(0);
    setStatus(val);
    filterData = { ...filterData, status: val.toString(), page: 0 };
    dispatch(getSubVendor(filterData));
  };

  const onRestFilter = () => {
    setStatus('');
    filterData = { ...filterData, status: '' };
    dispatch(getSubVendor(filterData));
  };

  const onSelectDateRange = (value) => {
    if (value === null) {
      filterData = { ...filterData, dateFrom: '', dateTo: '' };
    } else {
      filterData = {
        ...filterData,
        dateFrom: handleDateFormating(value[0]),
        dateTo: handleDateFormating(value[1]),
      };
    }
    dispatch(getSubVendor(filterData));
  };

  const onSearch = debounce((e) => {
    setPage(0);
    setSearch(e);
    const searchFilterData = {
      ...filterData,
      search: e,
      page: 0,
    };
    dispatch(getSubVendor(searchFilterData));
  }, 1000);

  //Adding new subvendor
  const onSumit = (val) => {
    const subVendorData = {
      mobile: val.number,
      firstName: val.name,
      lastName: '',
      email: val.email,
      countryCode: '+91',
      vendorId: companyId,
      companyName: val.name,
      isB2B: 'true',
    };
    dispatch(postAddSubVendor(subVendorData));
    toggle();
    setType('');
  };

  //editing subvendor
  const onDialog = (val, code) => {
    const profileData = {
      subVendorId: id,
      id: companyId,
      data: {
        firstName: val?.name,
        lastName: '',
        email: val?.email,
        countryCode: '+91',
        mobile: val?.number,
        companyName: val?.name,
        location: val?.address,
        isB2B: 'true',
      },
    };
    dispatch(patchUpdateSubVendor(profileData));
    setModelOpen(false);
    setType('');
  };

  const onClickMoreIcon = (data, type) => {
    const value = {
      vendorName: data?.vendorName.trim(),
      email: data?.email,
      number: data?.mobile,
      address: data?.address,
      city: data?.city,
      state: data?.state,
      name: data?.companyName,
    };
    setDefaultValue(value);
    setId(data.id);
    let statusAction = '';
    switch (type) {
      case 'Deactivate':
        statusAction = 'InActive';
        break;
      case 'Activate':
        statusAction = 'Active';
        break;
      case 'Block':
        statusAction = 'Blocked';
        break;
      case 'Unblock':
        statusAction = 'Active';
        break;
      default:
        break;
    } if (type === 'Edit') {
      setType(type);
      setModelOpen(true);
    } else if (statusAction !== '') {
      const profileData = {
        subVendorId: data.id,
        page:page,
        pageSize:rowsPerPage,
        search:search,
        data: {
          status: statusAction,
          isB2B: 'true',
        },
      };
      dispatch(patchUpdateSubVendor({ ...profileData, id: companyId }));
    } 
  };

  const handleClose = () => {
    setModelOpen(false);
  };

   //roles and permissions 
   const roleAndPermissions = useSelector((state) => state?.getRolesAndPermissions?.rolesAndPermissions);
   const subVendorRoleEnum = roleAndPermissionEnum.subvendor
   const accessForAdd = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {defaultAllAccess: subVendorRoleEnum.all, customAccess: subVendorRoleEnum.add});
   const accessForOnlyView = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.subVendorView});
   const accessForOnlyEdit = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.subVendorEdit});
   const accessForOnlyActivate = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.subVendorActivate});

   const accessForOnlyBlock = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.subVendorBlock});

   const accessForOnlyAdd = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.subVendorAdd});
 
   const viewMoreIcon = (accessForAdd || accessForOnlyEdit || accessForOnlyActivate || accessForOnlyBlock )
   const addButton = (accessForAdd ||accessForOnlyAdd )

  return (
    <Box>
      <CommonButtonSubHeader
        btnName={addButton && 'Sub-vendor'}
        filterdata={filterdata}
        btnAction={toggle}
        onSelectDateRange={onSelectDateRange}
        onFilterChange={onFilterChange}
        onRestFilter={onRestFilter}
        tabName={'company'}
        // search={'true'}
        height={true}
        onSearchQuery={onSearch}
        defaultStatus={status}
      />
      {subVendorDetailsLoader ? (
        <Box>
          <BackDrop/>
        </Box>
      ) : (
        <CommonTable
          data={subVendorDetails}
          tableOnClickRow={tableOnClickRow}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          page={page}
          rowsPerPage={rowsPerPage}
          onClickMoreIcon={onClickMoreIcon}
          isClickable={true}
          viewMoreIcon={!viewMoreIcon}
          tabName={'subVendorTable'}
        />
      )}

      <CommonDialog
        className="mb20"
        open={open}
        handleClose={toggle}
        button={'dialogButton'}
        onSubmittBtn={onSumit}
        selectType={'Create'}
        type={'Sub-vendor'}
        defaultValues={cityManagerName}
        formData={subVendorDialogData}
      />

      {modelOpen ? (
        <CommonDialog
          open={modelOpen}
          handleClose={handleClose}
          formData={subVendorDialogData}
          button={'dialogButton'}
          onSubmittBtn={onDialog}
          type={'Edit ' + 'Sub-Vendor' + ' '}
          selectType={'edit'}
          defaultValues={defaultValue}
        />
      ) : null}
    </Box>
  );
};

export default SubVendors;
